const baseApiRoute = '/api/v1/'
export const apiRoutes = {
  base: baseApiRoute,
  login: baseApiRoute + 'sessions',
}
